import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Register Service Worker - controleer regelmatig op updates (PWA). Bij falen (bijv. sw.js niet bereikbaar op Vercel) geen blokkade.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        setInterval(() => {
          if (registration) registration.update().catch(() => {});
        }, 60000);
      })
      .catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
